import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { RequestBody } from '@app/core/interfaces/admin.interface';
import { CodeFamily } from '@app/core/interfaces/product.interface';
import { Ticket } from '@app/core/interfaces/ticket.interface';
import { AnalysisService } from '@app/core/services/analysis.service';
import { BattVoloPdfService } from '@app/core/services/batt-volo-pdf.service';
import { CartService } from '@app/core/services/cart.service';
import { HonorCardPdfService } from '@app/core/services/honor-card-pdf.service';
import { PdfService } from '@app/core/services/pdf.service';
import { environment } from 'environments/environment';

@Component({
  selector: 'app-download-ticket',
  templateUrl: './download-ticket.component.html',
  styleUrl: './download-ticket.component.scss',
  standalone: false
})
export class DownloadTicketComponent {

  shortCode: string;

  constructor(private activeRoute: ActivatedRoute, private pdfService: PdfService,
    private cartService: CartService, private battVoloPdfService: BattVoloPdfService,
    private honorCardPdfService: HonorCardPdfService, private analysisService: AnalysisService) { 

    this.activeRoute.paramMap.subscribe(params => {

      this.shortCode = params.get("shortCode");

      this.downloadPdf(this.shortCode);
      
    });

  }

  downloadPdf(shortCode: string) {

    if (shortCode === null || shortCode === undefined || shortCode === "") {
      return;
    }

    this.loadTicket(shortCode);

  }

  ticketPdf(ticket: Ticket) {

    if (ticket.codeFamily == CodeFamily.HONOR_CARD) {
      this.honorCardPdfService.generatePdf([ticket]);
    } else {
      this.cartService.setTicketList([ticket]);
      this.pdfService.generatePdf();
    }

  }

  battVoloCert(ticket: Ticket) {
    this.battVoloPdfService.generatePdf([ticket]);
  }

  loadTicket(shortCode: string) {

    if (shortCode === null || shortCode === undefined || shortCode === "") {
      return;
    }

    // const reqBody: RequestBody = {
    //   paging: true,
    //   page: 0,
    //   rows: environment.rows,
    //   summary: true,
    //   orderBy: 'id', // tsCreated
    //   direction: 'DESC',
    //   filters: {
    //     PRODUCT: {
    //       id: null,
    //       productName: null,
    //     },
    //     PRODUCT_FAMILY: {
    //       id: null
    //     },
    //     CUSTOMER: {
    //       id: null,
    //       customerEmail: null
    //     },
    //     ORDER: {
    //       id: null
    //     },
    //     SALE:  {
    //       id: null,
    //       fromDate: null,
    //       toDate: null
    //     },
    //     TICKET: {
    //       ticketState: null,
    //       ticketCode: shortCode
    //     },
    //     RESELLER: {
    //       id: []
    //     }
    //   }
    // };

    this.analysisService.ticketByShortCode(shortCode).subscribe((response) => {
      
      const { data } = response;

      if (data) {

        const ticket: Ticket = data;
        
        if (ticket.codeFamily == CodeFamily.BATT_VOLO) { 
          this.battVoloCert(ticket);
        } else {
          this.ticketPdf(ticket);
        }

      }

    });

  }

}
